import Spinner from '@rio-cloud/rio-uikit/Spinner';

export const MainLoadingIndicator = () => (
    <div className={'height-100vh display-flex justify-content-center align-items-center'}>
        <Spinner isDoubleSized={true} />
    </div>
);
